export { default, type AdditionalInfo } from './AdditionalInfoSection';
